import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useContent } from "@/lib/content";
import { PayStep } from "@/components/site/PayStep";
import { Confirmation } from "@/components/site/Booking";

const Shell = ({ children }) => (
  <main className="pay-page" data-testid="pay-page">
    <div className="pay-page-inner">
      <Link to="/" className="back-link" data-testid="pay-back-link"><ArrowLeft size={14} /> Wax Moi Day Spa</Link>
      <img src="/brand/logo-black.png" alt="Wax Moi" className="pay-logo" />
      {children}
    </div>
  </main>
);

export default function Pay() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true });
  const content = useContent().data;
  const auth = { booking_id: params.get("b") || "", token: params.get("t") || "" };

  useEffect(() => {
    api.post("/bookings/lookup", auth)
      .then(({ data }) => setState(data))
      .catch((err) => setState({ error: formatApiError(err) }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (state.loading || !content) return <Shell><p className="muted-sm">Loading your booking…</p></Shell>;
  if (state.error) return <Shell><p className="form-error" data-testid="pay-error">This payment link isn't valid. Please contact the spa.</p></Shell>;
  if (state.paid || !state.can_pay) {
    const b = state.paid || state.booking;
    if (state.paid || ["confirmed", "needs_review", "completed"].includes(b.status)) return <Shell><Confirmation b={b} /></Shell>;
    return (
      <Shell>
        <div className="form" data-testid="pay-blocked">
          <AlertCircle size={30} color="var(--pink)" />
          <h3>{b.treatment}</h3>
          <p className="confirm-detail">{b.preferred_date} at {b.time_label}</p>
          <p data-testid="pay-blocked-reason">{state.reason}</p>
          <a className="btn gold" href={`tel:${content.contact.phone_call}`} data-testid="pay-call-button">Call {content.contact.phone_call_label}</a>
        </div>
      </Shell>
    );
  }
  return <Shell><PayStep booking={state.booking} payment={state.payment} onPaid={(b) => setState({ paid: b })} /></Shell>;
}
